"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getMembers = void 0;

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _dialog = _interopRequireDefault(require("britive-design-system/core/components/dialog"));

var _textarea = _interopRequireDefault(require("britive-design-system/core/components/textarea"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _commonConstants = require("../../../utils/common-constants");

var _constants = require("./constants");

var _genericConditions = _interopRequireDefault(require("../../policy-admin/view-policy/generic-conditions"));

var _approvals = _interopRequireDefault(require("../../policy-admin/view-policy/approvals"));

var _general = _interopRequireDefault(require("../../policy-admin/view-policy/general"));

var _members = _interopRequireDefault(require("../../policy-admin/view-policy/members"));

var _stepUpVerification = _interopRequireDefault(require("../../policy-admin/view-policy/step-up-verification"));

var _saResourcePermission = _interopRequireDefault(require("../../policy-admin/view-policy/sa-resource-permission"));

var _saResourceLabels = _interopRequireDefault(require("../../policy-admin/view-policy/sa-resource-labels"));

var _view = _interopRequireDefault(require("../../../components/advanced-settings/view"));

var _commonUtils = require("../../../utils/common-utils");

var _constants2 = require("../../batch-eval/constants");

var _reactRedux = require("react-redux");

var _utils = require("../utils");

var _associations = _interopRequireDefault(require("../../policy-admin/add-policy/steps/associations"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.view-policy-outer-wrapper .view-policy-main-container {\n  overflow-y: auto;\n  height: calc(100vh - 160px);\n  padding-left: 3.5rem;\n  padding-right: 3.5rem; }\n  .view-policy-outer-wrapper .view-policy-main-container::-webkit-scrollbar {\n    width: 0.5rem;\n    height: 0.5rem; }\n  .view-policy-outer-wrapper .view-policy-main-container::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n    margin-top: 0.125rem; }\n  .view-policy-outer-wrapper .view-policy-main-container::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #c6c6c6; }\n  .view-policy-outer-wrapper .view-policy-main-container::-webkit-scrollbar-thumb:hover {\n    background-color: #6f6f6f; }\n  .view-policy-outer-wrapper .view-policy-main-container .policy-render-class {\n    display: flex;\n    height: 100%; }\n  .view-policy-outer-wrapper .view-policy-main-container .header-class {\n    margin-top: 2rem;\n    padding-bottom: 0.5rem;\n    border-bottom: 1px solid #a8a8a8; }\n  .view-policy-outer-wrapper .view-policy-main-container .margin-top-32 {\n    margin-top: 2rem; }\n  .view-policy-outer-wrapper .view-policy-main-container .margin-top-8 {\n    margin-top: 0.5rem; }\n  .view-policy-outer-wrapper .view-policy-main-container .margin-top-10 {\n    margin-top: 0.625rem; }\n  .view-policy-outer-wrapper .view-policy-main-container .tag-container {\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 0.625rem;\n    width: 50%;\n    max-height: 7.5rem;\n    overflow-y: auto;\n    min-height: 1.25rem; }\n    .view-policy-outer-wrapper .view-policy-main-container .tag-container::-webkit-scrollbar {\n      width: 0.5rem;\n      height: 0.5rem; }\n    .view-policy-outer-wrapper .view-policy-main-container .tag-container::-webkit-scrollbar-track {\n      border-radius: 0.5rem;\n      margin-top: 0.125rem; }\n    .view-policy-outer-wrapper .view-policy-main-container .tag-container::-webkit-scrollbar-thumb {\n      border-radius: 0.5rem;\n      background-color: #c6c6c6; }\n    .view-policy-outer-wrapper .view-policy-main-container .tag-container::-webkit-scrollbar-thumb:hover {\n      background-color: #6f6f6f; }\n  .view-policy-outer-wrapper .view-policy-main-container .typography-page-section-header,\n  .view-policy-outer-wrapper .view-policy-main-container .typography-label-02 {\n    color: #393939; }\n  .view-policy-outer-wrapper .view-policy-main-container .typography-label-01 {\n    color: #525252; }\n  .view-policy-outer-wrapper .view-policy-main-container .bds-textarea-box-read-only {\n    background-color: #f4f4f4 !important;\n    color: #525252 !important; }\n  .view-policy-outer-wrapper .view-policy-main-container .add-role-table-permissions {\n    width: 100%;\n    height: 100%;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden; }\n  .view-policy-outer-wrapper .view-policy-main-container .approval-loader-container {\n    display: flex;\n    justify-content: center; }\n\n.view-policy-outer-wrapper .view-policy-permission-action-pill-container {\n  margin-bottom: 0.5rem;\n  margin-right: 1rem; }\n\n.view-policy-outer-wrapper .button-main-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #f4f4f4 !important;\n  padding-left: 3.5rem;\n  padding-right: 3.5rem;\n  padding-bottom: 1rem; }\n\n.view-policy-outer-wrapper .child-button-main-container {\n  display: flex;\n  justify-content: space-between; }\n  .view-policy-outer-wrapper .child-button-main-container button {\n    margin-right: 0.625rem; }\n\n.view-role-permission-details-modal-wrapper .role-permission-wrapper {\n  margin-bottom: 2rem; }\n\n.view-role-permission-details-modal-wrapper .add-entity-input-spacing {\n  margin-bottom: 0.5rem; }\n\n.view-role-permission-details-modal-wrapper .add-entity-modal-label {\n  padding-bottom: 0.25rem;\n  color: #393939; }\n\n.view-role-permission-details-modal-wrapper .view-action-pill {\n  display: flex;\n  flex-wrap: wrap;\n  width: 28rem; }\n  .view-role-permission-details-modal-wrapper .view-action-pill .pill-adjust {\n    padding-right: 1rem;\n    padding-bottom: 0.5rem; }\n\n.view-role-permission-details-modal-wrapper .action-wrapper-pill {\n  padding-right: 1rem;\n  padding-bottom: 0.5rem; }\n\n.view-role-permission-details-modal-wrapper .add-entity-modal-value {\n  color: #525252; }\n\n.view-role-permission-details-modal-wrapper .margin-top-32 {\n  margin-top: 2rem; }\n\n.view-role-permission-details-modal-wrapper .margin-top-8 {\n  margin-top: 0.5rem; }\n\n.view-role-permission-details-modal-wrapper .margin-top-10 {\n  margin-top: 0.625rem; }\n\n.view-role-permission-details-modal-wrapper .typography-label-02 {\n  color: #393939; }\n\n.view-role-permission-details-modal-wrapper .typography-label-01 {\n  color: #525252; }\n\n.view-role-permission-details-modal-wrapper .view-policy-permission-action-pill-container {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n  margin-right: 1rem; }\n\n.view-role-permission-details-modal-wrapper .role-label-modal-container {\n  margin-bottom: 0.5rem; }\n\n.view-role-permission-details-modal-wrapper .role-value-modal-container {\n  margin-bottom: 2rem;\n  margin-top: 0.5rem; }\n";
  var fileName = "compone_PolicyView";
  var element = document.querySelector("style[data-sass-component='compone_PolicyView']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var PolicyView = function PolicyView(_ref) {
  var _applicationRootData$;

  var policyViewData = _ref.policyViewData,
      policyViewLoading = _ref.policyViewLoading,
      policyDeleteLoading = _ref.policyDeleteLoading,
      deletePolicyById = _ref.deletePolicyById,
      openNotification = _ref.openNotification,
      getPolicyById = _ref.getPolicyById,
      setPageHeader = _ref.setPageHeader,
      history = _ref.history,
      resetPolicyView = _ref.resetPolicyView,
      togglePolicyRequest = _ref.togglePolicyRequest,
      policyToggleLoading = _ref.policyToggleLoading,
      fetchedUsers = _ref.fetchedUsers,
      fetchedUsersStatus = _ref.fetchedUsersStatus,
      fetchedGroups = _ref.fetchedGroups,
      fetchedGroupsStatus = _ref.fetchedGroupsStatus,
      fetchedServiceIdentities = _ref.fetchedServiceIdentities,
      fetchedServiceIdentitiesStatus = _ref.fetchedServiceIdentitiesStatus,
      fetchedTokens = _ref.fetchedTokens,
      fetchedTokensStatus = _ref.fetchedTokensStatus,
      policyEvalData = _ref.policyEvalData,
      getApplicationsList = _ref.getApplicationsList,
      getPolicyByName = _ref.getPolicyByName,
      getPolicyByIdReset = _ref.getPolicyByIdReset,
      getPolicyByNameReset = _ref.getPolicyByNameReset,
      policyViewJSONLoading = _ref.policyViewJSONLoading,
      policyViewJSONData = _ref.policyViewJSONData,
      initSpinnerOverlay = _ref.initSpinnerOverlay,
      consumerListStatus = _ref.consumerListStatus,
      consumerEntityId = _ref.consumerEntityId,
      redirectPath = _ref.redirectPath;
  var location = (0, _reactRouterDom.useLocation)();

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      isFormMode = _useState2[0],
      setIsFormMode = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDeleteDialog = _useState4[0],
      setDeleteModal = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      deleteTitle = _useState6[0],
      setDeleteTitle = _useState6[1];

  var _useState7 = (0, _react.useState)(''),
      _useState8 = _slicedToArray(_useState7, 2),
      deleteMessage = _useState8[0],
      setDeleteMessage = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      openToggleDialog = _useState10[0],
      setOpenToggleDialog = _useState10[1];

  var _useState11 = (0, _react.useState)({
    id: '',
    status: '',
    history: history
  }),
      _useState12 = _slicedToArray(_useState11, 2),
      togglePolicy = _useState12[0],
      setTogglePolicy = _useState12[1];

  var _useState13 = (0, _react.useState)(''),
      _useState14 = _slicedToArray(_useState13, 2),
      toggleLoadingMessage = _useState14[0],
      setToggleLoadingMessage = _useState14[1];

  var _useState15 = (0, _react.useState)(null),
      _useState16 = _slicedToArray(_useState15, 2),
      membersData = _useState16[0],
      setMembersData = _useState16[1];

  var _useState17 = (0, _react.useState)({}),
      _useState18 = _slicedToArray(_useState17, 2),
      policiesEvalData = _useState18[0],
      setPoliciesEvalData = _useState18[1];

  var _useParams = (0, _reactRouterDom.useParams)(),
      policyId = _useParams.id;

  var _useState19 = (0, _react.useState)([]),
      _useState20 = _slicedToArray(_useState19, 2),
      notificationMediumData = _useState20[0],
      setNotificationMediumData = _useState20[1];

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    var _state$policyReducer, _state$policyReducer$;

    return state === null || state === void 0 ? void 0 : (_state$policyReducer = state.policyReducer) === null || _state$policyReducer === void 0 ? void 0 : (_state$policyReducer$ = _state$policyReducer.add) === null || _state$policyReducer$ === void 0 ? void 0 : _state$policyReducer$.notificationMedium;
  }),
      notificationMediumList = _useSelector.data,
      notificationMediumDataStatus = _useSelector.status;

  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
    var _state$policyReducer2, _state$policyReducer3;

    return state === null || state === void 0 ? void 0 : (_state$policyReducer2 = state.policyReducer) === null || _state$policyReducer2 === void 0 ? void 0 : (_state$policyReducer3 = _state$policyReducer2.associationsReducer) === null || _state$policyReducer3 === void 0 ? void 0 : _state$policyReducer3.scopesRoot;
  }),
      scopesRootData = _useSelector2.data;

  var _useSelector3 = (0, _reactRedux.useSelector)(function (state) {
    var _state$policyReducer4, _state$policyReducer5;

    return state === null || state === void 0 ? void 0 : (_state$policyReducer4 = state.policyReducer) === null || _state$policyReducer4 === void 0 ? void 0 : (_state$policyReducer5 = _state$policyReducer4.associationsReducer) === null || _state$policyReducer5 === void 0 ? void 0 : _state$policyReducer5.applicationRoot;
  }),
      applicationRootData = _useSelector3.data;

  var requiresHierarchicalModel = applicationRootData === null || applicationRootData === void 0 ? void 0 : (_applicationRootData$ = applicationRootData.catalogApplication) === null || _applicationRootData$ === void 0 ? void 0 : _applicationRootData$.requiresHierarchicalModel;
  (0, _react.useEffect)(function () {
    if (!(0, _isEmpty.default)(policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.condition)) {
      var approver = policyViewData.condition;

      if (!(0, _isEmpty.default)(approver === null || approver === void 0 ? void 0 : approver.approval)) {
        var _approver$approval;

        var genre_ids = approver === null || approver === void 0 ? void 0 : (_approver$approval = approver.approval) === null || _approver$approval === void 0 ? void 0 : _approver$approval.notificationMedium;
        var filteredGenre = notificationMediumList === null || notificationMediumList === void 0 ? void 0 : notificationMediumList.filter(function (element) {
          return genre_ids.includes(element.id);
        });
        setNotificationMediumData(filteredGenre);
      }
    }
  }, [notificationMediumList, policyViewData]);
  (0, _react.useEffect)(function () {
    getApplicationsList();
    getPolicyById(policyId, history, _commonConstants.papServiceConsumer, consumerEntityId, redirectPath);
    setPageHeader(_constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.pageTitle, []);
    return function () {
      getPolicyByIdReset();
      getPolicyByNameReset();
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (!(0, _isEmpty.default)(policyEvalData)) {
      setPoliciesEvalData({
        add: policyEvalData[_constants2.policyActions === null || _constants2.policyActions === void 0 ? void 0 : _constants2.policyActions.create] === _commonConstants.ALLOW,
        edit: policyEvalData[_constants2.policyActions === null || _constants2.policyActions === void 0 ? void 0 : _constants2.policyActions.update] === _commonConstants.ALLOW,
        delete: policyEvalData[_constants2.policyActions === null || _constants2.policyActions === void 0 ? void 0 : _constants2.policyActions.delete] === _commonConstants.ALLOW,
        view: policyEvalData[_constants2.policyActions === null || _constants2.policyActions === void 0 ? void 0 : _constants2.policyActions.read] === _commonConstants.ALLOW,
        list: policyEvalData[_constants2.policyActions === null || _constants2.policyActions === void 0 ? void 0 : _constants2.policyActions.list] === _commonConstants.ALLOW
      });
    } else {
      setPoliciesEvalData({
        add: true,
        edit: true,
        delete: true,
        view: true,
        list: true
      });
    }
  }, [policyEvalData]);

  var areResourcesLoaded = function areResourcesLoaded() {
    return (0, _commonUtils.isSuccess)(fetchedUsersStatus) && (0, _commonUtils.isSuccess)(fetchedGroupsStatus) && (0, _commonUtils.isSuccess)(fetchedServiceIdentitiesStatus);
  };

  (0, _react.useEffect)(function () {
    if (areResourcesLoaded() && !policyViewLoading && !(0, _isEmpty.default)(policyViewData)) {
      var fetchedMembers = {
        users: fetchedUsers.result,
        groups: fetchedGroups.result,
        tokens: fetchedTokens.result,
        serviceIdentities: fetchedServiceIdentities.result
      };
      var members = getMembers(policyViewData.members, fetchedMembers, false);
      setMembersData(members);
    }
  }, [fetchedUsersStatus, fetchedGroupsStatus, fetchedServiceIdentitiesStatus, fetchedTokensStatus, policyViewLoading]);
  (0, _react.useEffect)(function () {
    initSpinnerOverlay({
      open: (0, _commonUtils.isLoading)(fetchedUsersStatus) || (0, _commonUtils.isLoading)(fetchedGroupsStatus) || (0, _commonUtils.isLoading)(fetchedServiceIdentitiesStatus) || (0, _commonUtils.isLoading)(fetchedTokensStatus) || policyViewLoading || policyDeleteLoading || policyToggleLoading || policyViewJSONLoading || (0, _commonUtils.isLoading)(consumerListStatus),
      size: _commonConstants.medium,
      message: policyToggleLoading ? toggleLoadingMessage : _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.loadingMessage
    });
  }, [policyViewLoading, policyDeleteLoading, policyToggleLoading, policyViewJSONLoading, fetchedUsersStatus, fetchedGroupsStatus, fetchedServiceIdentitiesStatus, fetchedTokensStatus, consumerListStatus]);
  (0, _react.useEffect)(function () {
    var _policyViewData$name;

    setPageHeader((_constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.pageTitle) + ' : ' + ((_policyViewData$name = policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.name) !== null && _policyViewData$name !== void 0 ? _policyViewData$name : ''), []);
  }, [policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.name]);

  var handleOpenModal = function handleOpenModal() {
    setDeleteTitle(_constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.deleteText);
    setDeleteMessage(_constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.deletePolicyConfirmMessage);
    setDeleteModal(true);
  };

  var handleDeleteDialogSubmit = function handleDeleteDialogSubmit() {
    deletePolicyById(policyId, history, _commonConstants.papServiceConsumer, consumerEntityId, redirectPath);
    setDeleteModal(false);
  };

  var handleDeleteDialogCancel = function handleDeleteDialogCancel() {
    setDeleteModal(false);
  };

  var goToListPage = function goToListPage() {
    var _location$state;

    history.push({
      pathname: redirectPath,
      state: {
        selectedPolicyId: location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.activePolicyId
      }
    });
    resetPolicyView();
  };

  var selectAndGoBack = function selectAndGoBack() {
    history.push({
      pathname: redirectPath,
      state: {
        selectedPolicyId: policyId
      }
    });
    resetPolicyView();
  };

  var handleTogglePolicyCancel = function handleTogglePolicyCancel() {
    setOpenToggleDialog(false);
    setTogglePolicy({});
  };

  var openPolicyToggle = function openPolicyToggle() {
    var id = policyViewData.id,
        isActive = policyViewData.isActive;
    var status = isActive ? _constants.enabledPolicy : _constants.disabledPolicy;

    if (isActive) {
      setToggleLoadingMessage(_constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.disableLoadingMessage);
    } else {
      setToggleLoadingMessage(_constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.enableLoadingMessage);
    }

    setTogglePolicy({
      id: id,
      status: status,
      history: history,
      consumer: _commonConstants.papServiceConsumer,
      consumerEntityId: consumerEntityId
    });
    setOpenToggleDialog(true);
  };

  var handleTogglePolicy = function handleTogglePolicy() {
    setOpenToggleDialog(false);
    togglePolicyRequest(togglePolicy);
  };

  var editPolicy = function editPolicy() {
    var id = policyViewData.id;
    history.push("".concat(redirectPath, "/manage/edit/").concat(id));
  };

  var handlePolicyClone = function handlePolicyClone(id) {
    history.push("".concat(redirectPath, "/manage/clone/").concat(id));
  };

  var handleModeChange = function handleModeChange() {
    if (isFormMode) {
      if ((0, _isEmpty.default)(policyViewJSONData)) {
        getPolicyByName(policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.name, history, _commonConstants.papServiceConsumer, consumerEntityId, redirectPath);
      }

      setIsFormMode(false);
    } else {
      setIsFormMode(true);
    }
  };

  var ViewPolicyActionButtons = function ViewPolicyActionButtons() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes === null || _constants.classes === void 0 ? void 0 : _constants.classes.buttonMainContainer
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes === null || _constants.classes === void 0 ? void 0 : _constants.classes.buttonChildContainer,
      "data-testid": _constants.policyConstantLabels === null || _constants.policyConstantLabels === void 0 ? void 0 : _constants.policyConstantLabels.viewPolicyButtonTestId
    }, (policiesEvalData === null || policiesEvalData === void 0 ? void 0 : policiesEvalData.edit) && !policyViewLoading && !(0, _isEmpty.default)(policyViewData) && /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.variant,
      size: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.size,
      onClick: function onClick() {
        editPolicy();
      }
    }, _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.editText), (policiesEvalData === null || policiesEvalData === void 0 ? void 0 : policiesEvalData.add) && /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.secVariant,
      size: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.size,
      onClick: function onClick() {
        return handlePolicyClone(policyId);
      }
    }, _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.cloneText), !policyViewLoading && (policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.name.toLowerCase()) !== _constants.tenantAdminPolicyName.toLowerCase() && (policiesEvalData === null || policiesEvalData === void 0 ? void 0 : policiesEvalData.edit) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.isActive) && !(policyViewData !== null && policyViewData !== void 0 && policyViewData.isDraft) && !(0, _isEmpty.default)(policyViewData) && /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.secVariant,
      size: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.size,
      onClick: function onClick() {
        openPolicyToggle();
      }
    }, _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.disableText), !(policyViewData !== null && policyViewData !== void 0 && policyViewData.isActive) && !(policyViewData !== null && policyViewData !== void 0 && policyViewData.isDraft) && !(0, _isEmpty.default)(policyViewData) && /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.secVariant,
      size: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.size,
      onClick: function onClick() {
        openPolicyToggle();
      }
    }, _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.enableText)), !policyViewLoading && !(policyViewData !== null && policyViewData !== void 0 && policyViewData.isReadOnly) && !(0, _isEmpty.default)(policyViewData) && /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.secVariant,
      size: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.size,
      onClick: handleOpenModal
    }, _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.deleteLabel), (policiesEvalData === null || policiesEvalData === void 0 ? void 0 : policiesEvalData.edit) && /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.secVariant,
      size: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.size,
      onClick: goToListPage
    }, _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.closeLabel)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.secVariant,
      size: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.size,
      onClick: handleModeChange
    }, isFormMode ? _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.viewJson : _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.viewEntity)));
  };

  var ViewPolicyForAccessRequest = function ViewPolicyForAccessRequest() {
    var _location$state2;

    var addPolicy = window.location.pathname.includes('/details/policies/create');
    var viewPolicy = window.location.pathname.includes('/request/manage/view');
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes === null || _constants.classes === void 0 ? void 0 : _constants.classes.buttonMainContainer
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes === null || _constants.classes === void 0 ? void 0 : _constants.classes.buttonChildContainer,
      "data-testid": _constants.policyConstantLabels === null || _constants.policyConstantLabels === void 0 ? void 0 : _constants.policyConstantLabels.viewPolicyButtonTestId
    }, addPolicy && (policiesEvalData === null || policiesEvalData === void 0 ? void 0 : policiesEvalData.edit) && !policyViewLoading && !(0, _isEmpty.default)(policyViewData) && !(policyViewData !== null && policyViewData !== void 0 && policyViewData.accessLevel) && /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.variant,
      size: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.size,
      onClick: function onClick() {
        editPolicy();
      }
    }, _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.editText), viewPolicy && !(location !== null && location !== void 0 && (_location$state2 = location.state) !== null && _location$state2 !== void 0 && _location$state2.selectedPolicyId) && /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: 'secondary',
      size: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.size,
      onClick: selectAndGoBack
    }, 'Select'), (policiesEvalData === null || policiesEvalData === void 0 ? void 0 : policiesEvalData.edit) && /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.secVariant,
      size: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.size,
      onClick: goToListPage
    }, _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.closeLabel)));
  };

  var associationsProps = {
    // Reusing the same validationHook structure as in the Add flow
    // Ensures scopes are populated from policyViewData for the View page
    validationHook: {
      values: {
        scopes: !(0, _isEmpty.default)(policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.scopes) ? policyViewData.scopes.map(function (scope) {
          return scope.value;
        }) : !(0, _isEmpty.default)(scopesRootData) ? scopesRootData.map(function (scope) {
          return scope.value;
        }) : []
      }
    },
    consumerEntityId: consumerEntityId,
    disabledTree: true
  };

  var ViewPolicyData = function ViewPolicyData() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes === null || _constants.classes === void 0 ? void 0 : _constants.classes.viewPolicyMainContainer
    }, /*#__PURE__*/_react.default.createElement(_general.default, {
      generalData: policyViewData,
      translatedStrings: _constants.translatedStrings,
      viewPolicyHeaders: _constants.viewPolicyHeaders,
      consumer: _commonConstants.papServiceConsumer
    }), /*#__PURE__*/_react.default.createElement(_members.default, {
      memberData: membersData,
      memberLabels: _constants.memberLabels,
      translatedStrings: _constants.translatedStrings,
      viewPolicyHeaders: _constants.viewPolicyHeaders,
      consumer: _commonConstants.papServiceConsumer
    }), /*#__PURE__*/_react.default.createElement(_genericConditions.default, {
      policyViewData: policyViewData,
      translatedStrings: _constants.translatedStrings,
      conditionsLabels: _constants.conditionsLabels,
      viewPolicyHeaders: _constants.viewPolicyHeaders
    }), (policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.accessLevel) && /*#__PURE__*/_react.default.createElement(_saResourcePermission.default, {
      policyViewData: policyViewData
    }), (0, _utils.isServerAccessPath)() && /*#__PURE__*/_react.default.createElement(_saResourceLabels.default, {
      policyViewData: policyViewData
    }), !(0, _isEmpty.default)(policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.settings) && /*#__PURE__*/_react.default.createElement(_view.default, {
      settings: policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.settings
    }), /*#__PURE__*/_react.default.createElement(_stepUpVerification.default, {
      policyViewData: policyViewData,
      translatedStrings: _constants.translatedStrings,
      conditionsLabels: _constants.conditionsLabels,
      viewPolicyHeaders: _constants.viewPolicyHeaders
    }), !(0, _isEmpty.default)(policyViewData) && !(0, _commonUtils.isLoading)(fetchedUsersStatus) && !(0, _commonUtils.isLoading)(fetchedGroupsStatus) && (policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.accessType) === _commonConstants.ALLOW && /*#__PURE__*/_react.default.createElement(_approvals.default, {
      policyViewData: policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.condition,
      fetchedUsers: fetchedUsers === null || fetchedUsers === void 0 ? void 0 : fetchedUsers.result,
      fetchedGroups: fetchedGroups === null || fetchedGroups === void 0 ? void 0 : fetchedGroups.result,
      notificationMediumData: notificationMediumData,
      notificationMediumDataStatus: notificationMediumDataStatus,
      viewPolicyHeaders: _constants.viewPolicyHeaders,
      approvalLabels: _constants.approvalLabels,
      translatedStrings: _constants.translatedStrings,
      consumer: _commonConstants.papServiceConsumer
    }), !(0, _isEmpty.default)(policyViewData) && (0, _commonUtils.isApplicationProfilePolicyPath)() && !requiresHierarchicalModel && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.container
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.headerClass
    }, /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: "pageSectionHeader"
    }, " Associations ")), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: "500px",
        width: "70%",
        overflow: "auto"
      }
    }, /*#__PURE__*/_react.default.createElement(_associations.default, associationsProps)))));
  };

  var ViewJsonData = function ViewJsonData() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes === null || _constants.classes === void 0 ? void 0 : _constants.classes.viewPolicyMainContainer
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes === null || _constants.classes === void 0 ? void 0 : _constants.classes.marginTop32
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.secVariant,
      size: _constants.policyButton === null || _constants.policyButton === void 0 ? void 0 : _constants.policyButton.size,
      onClick: function onClick() {
        navigator.clipboard.writeText(JSON.stringify(policyViewJSONData, undefined, 4));
        openNotification({
          open: true,
          type: _commonConstants.successNotificationType,
          title: _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.copyMessage,
          duration: 3000
        });
      }
    }, _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.copyText)), /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes === null || _constants.classes === void 0 ? void 0 : _constants.classes.marginTop8
    }, /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: "label2"
    }, " ", _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.policyJsonText, " "), /*#__PURE__*/_react.default.createElement(_textarea.default, {
      height: "60vh",
      value: JSON.stringify(policyViewJSONData, undefined, 4),
      readOnly: true,
      onChange: function onChange() {}
    })));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    role: _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.mainRoleText,
    className: _constants.classes.viewPolicyOuterWrapper
  }, (0, _utils.isAccessBuilderPath)() ? /*#__PURE__*/_react.default.createElement(ViewPolicyForAccessRequest, null) : /*#__PURE__*/_react.default.createElement(ViewPolicyActionButtons, null), isFormMode ? /*#__PURE__*/_react.default.createElement(ViewPolicyData, null) : /*#__PURE__*/_react.default.createElement(ViewJsonData, null), openDeleteDialog && /*#__PURE__*/_react.default.createElement(_dialog.default, {
    width: 400,
    height: 250,
    type: 'alert',
    title: deleteTitle,
    message: deleteMessage,
    primaryButtonText: _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.yesDeleteText,
    secondaryButtonText: _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.noText,
    onSubmit: handleDeleteDialogSubmit,
    onCancel: handleDeleteDialogCancel
  }), openToggleDialog && /*#__PURE__*/_react.default.createElement(_dialog.default, {
    type: 'alert',
    title: (0, _constants.getTogglePolicyConfirmTitle)(togglePolicy.status),
    message: (0, _constants.getTogglePolicyConfirmMessage)(togglePolicy.status),
    primaryButtonText: (0, _constants.getTogglePolicyLabel)(togglePolicy.status),
    secondaryButtonText: _constants.translatedStrings === null || _constants.translatedStrings === void 0 ? void 0 : _constants.translatedStrings.noText,
    onSubmit: handleTogglePolicy,
    onCancel: handleTogglePolicyCancel
  }));
};

var getMemberObjects = function getMemberObjects(members, membersData, idProperty) {
  var actualMembers = [];

  if (members) {
    var actualMember = null;

    var _loop = function _loop(itr) {
      actualMember = membersData === null || membersData === void 0 ? void 0 : membersData.find(function (member) {
        return member[idProperty] === members[itr];
      });

      if (actualMember) {
        actualMembers.push({
          name: actualMember.name || actualMember.channelName,
          status: actualMember.status
        });
      }
    };

    for (var itr = 0; itr < members.length; itr++) {
      _loop(itr);
    }

    if (!actualMember && members.length === 1 && members[0].length === 1) {
      actualMembers.push('*');
    }
  }

  actualMembers.sort(function (member1, member2) {
    return ((member1 === null || member1 === void 0 ? void 0 : member1.name) || '').localeCompare(member2 === null || member2 === void 0 ? void 0 : member2.name);
  });
  return actualMembers;
}; // This function has been used in policyViewApproval.jsx


var getMembers = function getMembers(members, fetchedMembers, isApproval) {
  var _members$users, _members$serviceIdent, _members$tags, _members$tokens;

  var actualUsers = [],
      actualGroups = [],
      actualServiceIdentities = [],
      actualTokens = [],
      actualChannels = [];
  var users = isApproval ? members === null || members === void 0 ? void 0 : members.users : members === null || members === void 0 ? void 0 : (_members$users = members.users) === null || _members$users === void 0 ? void 0 : _members$users.map(function (_ref2) {
    var id = _ref2.id;
    return id;
  });
  var serviceIdentities = members === null || members === void 0 ? void 0 : (_members$serviceIdent = members.serviceIdentities) === null || _members$serviceIdent === void 0 ? void 0 : _members$serviceIdent.map(function (_ref3) {
    var id = _ref3.id;
    return id;
  });
  var tags = isApproval ? members === null || members === void 0 ? void 0 : members.tags : members === null || members === void 0 ? void 0 : (_members$tags = members.tags) === null || _members$tags === void 0 ? void 0 : _members$tags.map(function (_ref4) {
    var id = _ref4.id;
    return id;
  });
  var tokens = members === null || members === void 0 ? void 0 : (_members$tokens = members.tokens) === null || _members$tokens === void 0 ? void 0 : _members$tokens.map(function (_ref5) {
    var id = _ref5.id;
    return id;
  });
  var channels = members === null || members === void 0 ? void 0 : members.channels;
  actualUsers = getMemberObjects(users, fetchedMembers === null || fetchedMembers === void 0 ? void 0 : fetchedMembers.users, 'userId');
  actualGroups = getMemberObjects(tags, fetchedMembers === null || fetchedMembers === void 0 ? void 0 : fetchedMembers.groups, 'userTagId');
  actualTokens = getMemberObjects(tokens, fetchedMembers === null || fetchedMembers === void 0 ? void 0 : fetchedMembers.tokens, 'id');
  actualServiceIdentities = getMemberObjects(serviceIdentities, fetchedMembers === null || fetchedMembers === void 0 ? void 0 : fetchedMembers.serviceIdentities, 'userId');
  actualChannels = getMemberObjects(channels, fetchedMembers === null || fetchedMembers === void 0 ? void 0 : fetchedMembers.channels, 'channelId');
  return {
    users: actualUsers && Boolean(actualUsers.length) ? actualUsers : undefined,
    tags: actualGroups && Boolean(actualGroups.length) ? actualGroups : undefined,
    tokens: actualTokens && Boolean(actualTokens.length) ? actualTokens : undefined,
    serviceIdentities: actualServiceIdentities && Boolean(actualServiceIdentities.length) ? actualServiceIdentities : undefined,
    channels: actualChannels && Boolean(actualChannels.length) ? actualChannels : undefined
  };
};

exports.getMembers = getMembers;
PolicyView.propTypes = {
  policyViewData: _propTypes.default.object,
  getPolicyById: _propTypes.default.func,
  deletePolicyById: _propTypes.default.func,
  resetPolicyView: _propTypes.default.func,
  setPageHeader: _propTypes.default.func,
  openNotification: _propTypes.default.func,
  history: _propTypes.default.any,
  policyViewLoading: _propTypes.default.bool,
  policyDeleteLoading: _propTypes.default.bool,
  togglePolicyRequest: _propTypes.default.func,
  policyToggleLoading: _propTypes.default.bool,
  fetchedUsers: _propTypes.default.any,
  fetchedUsersStatus: _propTypes.default.string,
  fetchedGroups: _propTypes.default.any,
  fetchedGroupsStatus: _propTypes.default.string,
  fetchedServiceIdentities: _propTypes.default.any,
  fetchedServiceIdentitiesStatus: _propTypes.default.string,
  fetchedTokens: _propTypes.default.any,
  fetchedTokensStatus: _propTypes.default.string,
  policyEvalData: _propTypes.default.object,
  getApplicationsList: _propTypes.default.func,
  applicationsListData: _propTypes.default.array,
  getPolicyByName: _propTypes.default.func,
  getPolicyByIdReset: _propTypes.default.func,
  getPolicyByNameReset: _propTypes.default.func,
  policyViewJSONLoading: _propTypes.default.bool,
  policyViewJSONData: _propTypes.default.object,
  initSpinnerOverlay: _propTypes.default.func,
  consumerList: _propTypes.default.array,
  consumerListStatus: _propTypes.default.string,
  consumerEntityId: _propTypes.default.string,
  redirectPath: _propTypes.default.string
};
var _default = PolicyView;
exports.default = _default;